var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 22,
    viewBox: "0 0 22 22",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.849 20.693-5.543-5.543c-.099-.099-.228-.15-.365-.15h-.443c1.474-1.594 2.376-3.721 2.376-6.063 0-4.937-4-8.937-8.937-8.937s-8.937 4-8.937 8.937 4 8.937 8.937 8.937c2.342 0 4.469-.902 6.063-2.372v.439c0 .137.056.266.15.365l5.543 5.543c.202.201.528.201.73 0l.426-.426c.201-.202.201-.528 0-.73zm-12.912-4.194c-4.18 0-7.562-3.381-7.562-7.562 0-4.18 3.381-7.562 7.562-7.562 4.18 0 7.562 3.381 7.562 7.562 0 4.18-3.381 7.562-7.562 7.562z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ba01b19240adc7958101096d051f1a7c.svg";
export { ForwardRef as ReactComponent };